import { AppointmentStatus, AppointmentKindSlug } from "common/types/scheduler";
import { PatientKind } from "common/types";
import { PastelColor } from "common/types/colors";

/** matches scheduler ClientAppointmentBulkUpdateSerializer */
export type AppointmentBulkUpdate = {
  appointment_ids: number[];
  status?: AppointmentStatus;
  start_datetime?: string;
  end_datetime?: string;
  reason?: string;
  resource?: number;
  kind?: number;
  calendar_id: number;
};

/** matches scheduler ClientAppointmentBulkCreateSerializer */
export type AppointmentBulkCreate = {
  calendar: number;
  patients: number[];
};

/** matches ClientAppointmentListView */
export type AppointmentListSearch = {
  appointment_ids?: number[];
};

/** matches scheduler FormRequestForClientAppointmentSerializer */
export type FormRequestForClientAppointment = {
  id: number;
  client_url: string;
  dashboard_link: string;
  form_name: string;
};

/** matches scheduler ClientAppointmentListSerializer */
export type ClientAppointment = {
  id: number;
  patient: PatientForClientAppointment;
  kind: AppointmentKindForClientAppointment | null;
  calendar: number;
  start_datetime: string;
  end_datetime: string;
  status: AppointmentStatus;
  reason: string;
  resource: CalendarResourceForClientAppointment | null;
};

/** matches scheduler ClientAppointmentWithFormsSerializer */
export type ClientAppointmentWithForms = {
  id: number;
  patient: PatientForClientAppointment;
  kind: AppointmentKindForClientAppointment | null;
  calendar: number;
  start_datetime: string;
  end_datetime: string;
  status: AppointmentStatus;
  reason: string;
  resource: CalendarResourceForClientAppointment | null;
  form_requests: FormRequestForClientAppointment[];
};

/** matches scheduler PatientForClientAppointmentSerializer */
export type PatientForClientAppointment = {
  id: number;
  name_display: string;
  universal_patient_id: number;
  species: PatientKind;
  species_display: string;
};

/** matches scheduler CalendarResourceForClientAppointmentSerializer */
export type CalendarResourceForClientAppointment = {
  id: number;
  name: string;
};

/** matches scheduler AppointmentKindForClientAppointmentSerializer */
export type AppointmentKindForClientAppointment = {
  id: number;
  label: string;
  slug: AppointmentKindSlug;
  color: PastelColor;
  includes_pickup_and_dropoff: boolean;
  description: string;
};

/** matches links AppointmentConfirmationLinkRule */
export type AppointmentConfirmationSearch = {
  appointment_ids: string;
};

/** matches scheduler CalendarResourceAvailabilityByResourceView */
export type CalendarResourceAvailabilityParams = {
  appointment_kind?: number;
  date: string;
};

/** matches scheduler type CalendarInfoAppointmentKindData */
export type CalendarInfoAppointmentKindData = {
  id: number;
  label: string;
  slug: AppointmentKindSlug;
  is_client_bookable: boolean;
};

/** matches scheduler CalendarInfoView */
export type CalendarInfo = {
  soonest_available_time: string | null;
  enabled_appointment_kinds: CalendarInfoAppointmentKindData[];
  is_client_booking_enabled: boolean;
  non_exotic_species: PatientKind[];
  allowed_species: PatientKind[];
};

export enum AppointmentBookingStep {
  Start = "start",
  Pets = "pets",
  Reason = "reason",
  DateTime = "datetime",
  Review = "review",
}
